import React from 'react';
import Calendar from './components/Calendar';

const DesignerCalendar = ({ calendar, designer, availabilityUrl: availabilityUrl }) => {
  const today = new Date();

  return (
    <Calendar
      calendar={calendar}
      designer={designer}
      availabilityUrl={availabilityUrl}
      date={today}
    />
  );
};

export default DesignerCalendar;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/DesignerCalendar.js